module.exports = __webpack_public_path__ + "img/Jump Casting41.cd780932.jpg";